import type { AgentThreadVo } from "@/api";
import { api } from "@/api";

interface FetchCommunityThreadsOptions {
  limit?: number;
  offset?: number;
}

const DEFAULT_LIMIT = 5;

const hasIdentifier = (
  thread: AgentThreadVo
): thread is AgentThreadVo & {
  id: string;
} => {
  return typeof thread.id === "string" && thread.id.length > 0;
};

export async function fetchCommunityThreads(
  options: FetchCommunityThreadsOptions = {}
) {
  const { limit = DEFAULT_LIMIT, offset = 0 } = options;
  const response = await api.threads.listCommunityThreads({
    offset,
    limit,
  });

  const list = response.data.list ?? [];

  return list.filter(hasIdentifier);
}
